import { connect } from 'react-redux';
import { isNull } from 'lodash';
import { push } from 'connected-react-router';
import { appNamedRoutes } from 'routes';
import { createAnswer, deleteAnswer, updateAnswer, finishSurvey } from 'actions';
import { getIsSurveyValid } from 'selectors';
import ASQSurvey from '../../components/asq/ASQSurvey';

const mapStateToProps = (state) => {
  return {
    isValid: getIsSurveyValid(state),
    survey: state.survey.survey,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChange: (id, params) => {
      dispatch(isNull(id) ? createAnswer(params) : updateAnswer(id, params))
    },
    onDelete: (id, params) => {
      dispatch(deleteAnswer(id, params))
    },
    onFinishSurvey: () => {
      dispatch(finishSurvey())
    },
    onGoBack: () => {
      const path = ownProps.locationFrom || appNamedRoutes.asqs;
      dispatch(push(path));
    },
  }
}

const ASQSurveyContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ASQSurvey)

export default ASQSurveyContainer;
